// extracted by mini-css-extract-plugin
export var equalColumn = "_ev-0";